import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { propertyConditionNames } from '@appcues/libcues';
import { Select } from 'next/components/ui';
import BaseClause from 'components/Common/Clauses/Base';
import { getEmptyClauseForConditionName } from 'utils/conditions';
import { selectFlows } from 'reducers/account/flows';
import { selectAccountSegments } from 'reducers/account/segments';
import { selectAccountUserEvents } from 'reducers/account/userEvents';
import ToggleableSelect from 'components/Common/Clauses/ToggleableSelect';

const Property = styled.div`
  ${Select} {
    margin-right: 10px;
    max-width: 155px;
    min-width: 120px;
  }
`;

function AudienceBaseClause(props) {
  const {
    children,
    clause,
    hasEvents,
    hasSegments,
    hasSteps,
    readOnly,
    replaceClause,
    skipSegments,
  } = props;

  const conditionNameOptions = [
    { value: propertyConditionNames.PROPERTIES, label: 'Property' },
    { value: propertyConditionNames.LANGUAGES, label: 'Language' },
    {
      value: propertyConditionNames.CONTENT,
      label: 'Flow',
      disabled: !hasSteps,
    },
    {
      value: propertyConditionNames.EVENT,
      label: 'Event',
      disabled: !hasEvents,
    },
  ];

  if (!skipSegments) {
    conditionNameOptions.push({
      value: propertyConditionNames.SEGMENTS,
      label: 'Segment',
      disabled: !hasSegments,
    });
  }

  const selected = conditionNameOptions.find(
    option => option.value === clause.conditionName
  );

  return (
    <BaseClause {...props}>
      <Property>
        <ToggleableSelect
          onChange={({ value }) =>
            replaceClause(clause.id, getEmptyClauseForConditionName(value))
          }
          operator
          options={conditionNameOptions}
          readOnly={readOnly}
          readOnlyContent={selected?.label || ''}
          value={selected}
        />
      </Property>
      {children}
    </BaseClause>
  );
}

AudienceBaseClause.propTypes = {
  children: PropTypes.node,
  clause: PropTypes.shape({
    conditionName: PropTypes.string,
    id: PropTypes.string,
  }),
  hasEvents: PropTypes.bool,
  hasSegments: PropTypes.bool,
  hasSteps: PropTypes.bool,
  readOnly: PropTypes.bool,
  replaceClause: PropTypes.func,
  skipSegments: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    hasSteps: Object.keys(selectFlows(state)).length,
    hasEvents: Object.keys(selectAccountUserEvents(state)).length,
    hasSegments: Object.keys(selectAccountSegments(state)).length,
  };
}

export default connect(mapStateToProps)(AudienceBaseClause);
